import Features from '../components/Features';
import { Box } from '@mui/material';

const FeaturesPage = () => {
  return (
    <Box sx={{ pt: 8 }}>
      <Features />
    </Box>
  );
};

export default FeaturesPage;
